<template>
  <!-- <q-page class="q-pa-md"> -->
    <div
      class="text-h6 q-py-xs"
      :class="this.$q.dark.mode ? '' : 'text-primary'"
    >
      <div class="text-caption text-bold q-pa-xs">
        As of :
        <!-- {{ convertDate(this.$store.state.market.asOfLive) }} -->
        {{ date }}
      </div>
      <PackageAuth>
        <template #authorized-content>
          <div class="row">
            <div class="col-12 col-md-4">
              <q-input
                dense
                filled
                v-model="date"
                capslock
                mask="date"
                :rules="['date']"
                class="text-bold"
              >
                <q-popup-proxy
                  ref="qDateProxy"
                  transition-show="scale"
                  transition-hide="scale"
                >
                  <q-date
                    v-model="calenderDate"
                    @input="() => $refs.qDateProxy.hide()"
                  />
                </q-popup-proxy>
                <q-icon
                  name="event"
                  class="text-grey text-h6 date-icon cursor-pointer q-pt-md"
                />
              </q-input>
            </div>
          </div>
          <q-table
            :class="
              $q.dark.mode === true
                ? 'table-sticky-header-column-dark'
                : 'table-sticky-header-column'
            "
            flat
            bordered
            :rows="computedCircuitSetupData"
            :columns="columns"
            :pagination="pagination"
            separator="cell"
            binary-state-sort
            :filter="filterSymbol"
            :filter-method="(rows) => filterSymbolData(rows, filterSymbol)"
          >
            <template v-slot:body-cell-symbol="props">
              <q-td :props="props">
                <div class="col">
                  {{ props.value }}
                  <q-tooltip>{{
                    allStocks.find((stock) => stock.symbol == props.value)?.name
                  }}</q-tooltip>
                </div>
              </q-td>
            </template>
          </q-table>
        </template>
      </PackageAuth>
    </div>
    <!-- end of else -->
  <!-- </q-page> -->
</template>

<script>
import { ref, onMounted, computed, watch } from "vue";

import useData from "src/use/data";
import { useStore } from "vuex";
import moment from "moment";
import { useQuasar } from "quasar";
import useUtils from "src/use/utils";
import PackageAuth from "src/components/Packages/PackageAuth.vue";

export default {
  name: "CircuitSetup",
  props: { symbol: { type: String } },
  components: {
    PackageAuth,
  },
  setup(props) {
    const $q = useQuasar();
    const store = useStore();
    const { CircuitSetup, CircuitSetupHistory } = useData();
    const { filterSymbolData } = useUtils();

    const filterSymbol = ref("");

    const isMarketOn = ref(false);
    const allStocks = ref([]);

    let date = ref(null);
    let calenderDate = ref(null);

    const circuitSetupData = ref([]);

    const filterData = ref("show_all");
    const myStocks = ref([]);
    const mySignals = ref(false);

    const isLiveDate = () => {
      let asOfLiveDate = store.state.market.asOfLive.split("T")[0];
      if (calenderDate.value === null)
        calenderDate.value = store.state.market.asOfLive.split("T")[0];
      return calenderDate.value.replaceAll("/", "-") === asOfLiveDate;
    };

    const getCircuitStatusAndStyle = (status) => {
      const isLive = isLiveDate();
      switch (true) {
        case isMarketOn.value && isLive:
          return {
            status: "InProgress",
            style: "font-weight: bold;",
          };
        case status < 1.5:
          return {
            status: `Completed`,
            style: "color:green; font-weight: bold;",
          };
        case status < 3:
          return {
            status: `Partial Completed`,
            style: "color:green; font-weight: bold;",
          };
        case status > 3:
          return {
            status: `Incompleted`,
            style: "color:red; font-weight: bold;",
          };
        default:
          return {
            status: "Unknown",
            style: "color:gray; font-weight: normal;",
          };
      }
    };

    async function loadLiveData(val = null) {
      $q.loading.show({});

      try {
        let asOfLive = store.state.market.asOfLive.split("T")[0];
        let resCircuitData = [];

        const selectedDate = calenderDate.value?.replaceAll("/", "-");

        if (
          selectedDate === null ||
          selectedDate === asOfLive ||
          selectedDate == undefined
        ) {
          resCircuitData = await CircuitSetup();
        } else {
          resCircuitData = await CircuitSetupHistory(selectedDate);
        }

        circuitSetupData.value = resCircuitData.data.sort(
          (a, b) => a.high_close - b.high_close
        );
      } catch (error) {
        console.error("Error loading live data:", error);
      } finally {
        $q.loading.hide();
      }
    }

    const computedCircuitSetupData = computed(() => {
      return circuitSetupData.value.filter((i) => i.symbol == props.symbol);
    });

    watch(calenderDate, (newVal, oldVal) => {
      if (oldVal != null) loadLiveData(newVal);
    });

    onMounted(async () => {
      if (store.state.market.asOfLive) {
        date.value = store.state.market.asOfLive.split("T")[0];
        myStocks.value =
          store.state.packages.packageStatus?.current_package?.stocks;
      } else {
        store.dispatch("market/marketStatusNew").then(() => {
          date.value = store.state.market.asOfLive.split("T")[0];
          myStocks.value =
            store.state.packages.packageStatus?.current_package?.stocks;
        });
      }
      await loadLiveData();

      if (!isMarketOn.value) {
        await store.dispatch("market/marketStatusNew");
        isMarketOn.value = store.state.market.marketStatus;
      }

      allStocks.value = store.state.core.allStocks || [];
      if (!allStocks.value.length) {
        await store.dispatch("core/getAllStocks");
        allStocks.value = store.state.core.allStocks;
      }
    });

    const columns = [
      {
        name: "date",
        label: "Circuit Setup time",
        field: "date",
        format: (val, row) => {
          return convertDate(val);
        },
        sortable: true,
        align: "left",
      },
      {
        name: "symbol",
        label: "Symbol",
        field: "symbol",
        sortable: true,
        align: "center",
      },
      {
        name: "close",
        label: "LTP",
        field: "close",
        sortable: true,
        align: "center",
      },
      {
        name: "open",
        label: "Open",
        field: "open",
        sortable: true,
        align: "center",
      },
      {
        name: "high",
        label: "High",
        field: "high",
        sortable: true,
        align: "center",
      },
      {
        name: "low",
        label: "Low",
        field: "low",
        sortable: true,
        align: "center",
      },
      {
        name: "high_close",
        label: "High - Ltp %",
        field: "high_close",
        format: (val, row) => {
          return parseFloat(val).toFixed(2);
        },
        sortable: true,
        align: "center",
      },
      {
        name: "high_open",
        label: "High - Open %",
        field: "high_open",
        sortable: true,
        format: (val, row) => {
          return parseFloat(val).toFixed(2);
        },
        align: "center",
      },
      {
        name: "status",
        label: "Circuit Status",
        field: "status",
        sortable: true,
        format: (val, row) => {
          const status = ((row.high - row.close) / row.close) * 100;
          return getCircuitStatusAndStyle(status)?.status;
        },
        style: (row) => {
          const status = ((row.high - row.close) / row.close) * 100;
          return getCircuitStatusAndStyle(status)?.style;
        },

        align: "center",
      },
    ];

    const pagination = {
      sortBy: "date",
      rowsPerPage: 0,
      descending: true,
    };

    const convertDate = (date) => moment(date).format("YYYY-MM-DD, hh:mm A");

    return {
      mySignals,
      calenderDate,
      computedCircuitSetupData,
      columns,
      pagination,
      allStocks,
      convertDate,
      filterSymbol,
      filterSymbolData,
      filterData,
      date,
    };
  },
};
</script>
